import React from "react";
import "./styles/TotalEcoContent.scss";
import BannerType1 from "./BannerType1";
import { useTranslation } from "react-i18next";
const TotalEcoContent = () => {
  const { t } = useTranslation();
  const gSeed = t("consulting.totalEco.gSeed.content", { returnObjects: true }) as { name: string; list: string[] }[];
  const calculation_example = t("consulting.totalEco.standard.calculationExample.content", { returnObjects: true }) as { case: { grade: string; rate: string }[]; calculate: string; result: string }[];
  const process = t("consulting.totalEco.standard.process.content", { returnObjects: true }) as { name: string; works: { work: string; type: string }[] }[];
  const efficiencyRating = t("consulting.totalEco.standard.certificationPeriod.efficiencyRating.content", { returnObjects: true }) as { color: string; period: string; des: string }[];
  const certification = t("consulting.totalEco.standard.certificationPeriod.certification.content", { returnObjects: true }) as { color: string; period: string; des: string }[];
  const responsibleOffice = t("consulting.totalEco.standard.responsibleOffice.content", { returnObjects: true }) as { name: string; list: { detail: string; source: string; type?: string }[] }[];

  return (
    <>
      <div className="total_eco_content_wrap">
        <BannerType1 path="/imgs/banner_consulting_total_eco.png" />
        <div className="contents">
          <div className="g_seed_wrap">
            <h2 className="title">{t("consulting.totalEco.gSeed.title")}</h2>
            <div className="des">{t("consulting.totalEco.gSeed.des")}</div>
            <div className="img_box">
              <img src="/imgs/image_g_seed.png" alt="g-seed" />
            </div>
            <div className="card_wrap">
              {gSeed.map((content, index) => {
                return (
                  <div className="card" key={`${content.name}_${index}`}>
                    <div className="title">{content.name}</div>
                    <ul>
                      {content.list.map((text, index2) => {
                        return <li key={`${text}_${index2}`}>{text}</li>;
                      })}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="construction_standards_wrap">
            <h2 className="title">{t("consulting.totalEco.standard.title")}</h2>
            <div className="process_wrap">
              <div className="calculation_example_wrap">
                <div className="title">{t("consulting.totalEco.standard.calculationExample.title")}</div>
                <div className="card_wrap">
                  {calculation_example.map((data, index) => {
                    return (
                      <div className="card" key={`${data.result}_${index}`}>
                        <div className="case_number">{`case ${index + 1}`}</div>
                        <div className="case_wrap">
                          {data.case.map((dat, index2) => {
                            return (
                              <div className="case" key={`${dat.rate}_${index2}`}>
                                <div className="name_wrap">
                                  {index2 === 0
                                    ? t("consulting.totalEco.standard.calculationExample.green")
                                    : index2 === 1
                                      ? t("consulting.totalEco.standard.calculationExample.energy")
                                      : index2 === 2
                                        ? t("consulting.totalEco.standard.calculationExample.zero")
                                        : t("consulting.totalEco.standard.calculationExample.intelligent")}
                                </div>
                                <div className="grade_wrap">
                                  {t("consulting.totalEco.standard.calculationExample.rating")} : {dat.grade}
                                </div>
                                <div className="rate_wrap">
                                  {t("consulting.totalEco.standard.calculationExample.wonRate")} : {dat.rate}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                        <div className="result_wrap">
                          <div className="label_wrap">{t("consulting.totalEco.standard.calculationExample.apply")}</div>
                          <div className="result">
                            <div className="calculation_wrap">{data.calculate}</div>
                            <div className="ment_wrap">{data.result}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="process_flow_wrap">
                <div className="title">{t("consulting.totalEco.standard.process.title")}</div>
                <div className="flow_wrap">
                  {process.map((data, index) => {
                    return (
                      <div className="process" key={`${data.name}_${index}`}>
                        <div className="name_wrap">{data.name}</div>
                        <div className="work_wrap">
                          {data.works.map((work, index) => {
                            return (
                              <div className={`work ${work.type === "orange" ? "orange_card" : ""}`} key={`${work}_work_${index}`}>
                                {work.work}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="certification_period_wrap">
                <div className="title">{t("consulting.totalEco.standard.certificationPeriod.title")}</div>
                <div className="content_box">
                  <div className="content">
                    <div className="efficiency_rating_wrap">
                      <div className="name">{t("consulting.totalEco.standard.certificationPeriod.efficiencyRating.name")}</div>
                      <div className="graph_wrap">
                        {efficiencyRating.map((data, index) => {
                          return (
                            <div className="graph" key={`efficiency_rating_key_${index}`}>
                              <div className="bar" style={{ backgroundColor: `${data.color}` }}></div>
                              <div className="period">{data.period}</div>
                              <div className="des">{data.des}</div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="certification_wrap">
                      <div className="name">{t("consulting.totalEco.standard.certificationPeriod.certification.name")}</div>
                      <div className="graph_wrap">
                        {certification.map((data, index) => {
                          return (
                            <div className="graph" key={`certification_key_${index}`}>
                              <div className="bar" style={{ backgroundColor: `${data.color}` }}></div>
                              <div className="period">{data.period}</div>
                              <div className="des">{data.des}</div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="responsible_office_wrap">
                <div className="title">{t("consulting.totalEco.standard.responsibleOffice.title")}</div>
                <div className="content">
                  {responsibleOffice.map((data, index) => {
                    return (
                      <div className="card" key={`responsibleOffice_${index}`}>
                        <div className="name">{data.name}</div>
                        {data.list.map((li, index2) => {
                          return (
                            <div className={`list ${li.type === "orange_card" ? "orange_card" : ""}`} key={`list_${li}_${index2}`}>
                              <div className="detail">{li.detail}</div>
                              <div className="source">{li.source}</div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* <div className="img_box">
                <img src="/imgs/construction_standards_relaxation_process.png" alt="process" />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TotalEcoContent;
